import formapimodalmedicinesview from "./medicineViews";

export default function formapimodalmedicinesPagination({
    data,
    pageno,
    pagesize,
    count
  })
  {
  return Object.freeze({
    
    data:data !== null ? formapimodalmedicinesview(data) : [],
    pageno,
    pagesize,
    count,
  });
  }